/**
 * Currency formatting utilities — INR (Indian numbering) ↔ USD (Western)
 */

export function formatINR(value, opts = {}) {
  const { compact = true } = opts;
  if (value === null || value === undefined || isNaN(value)) return "—";
  const v = Number(value);
  const sign = v < 0 ? "-" : "";
  const abs = Math.abs(v);
  if (compact) {
    if (abs >= 1e7) return `${sign}₹${(abs / 1e7).toLocaleString("en-IN", { maximumFractionDigits: 2 })} Cr`;
    if (abs >= 1e5) return `${sign}₹${(abs / 1e5).toLocaleString("en-IN", { maximumFractionDigits: 2 })} L`;
    if (abs >= 1e3) return `${sign}₹${abs.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
    return `${sign}₹${abs.toLocaleString("en-IN", { maximumFractionDigits: 2 })}`;
  }
  return `${sign}₹${abs.toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}

export function formatUSD(value, opts = {}) {
  const { compact = true, rate = 83 } = opts;
  if (value === null || value === undefined || isNaN(value)) return "—";
  const v = Number(value) / rate;
  const sign = v < 0 ? "-" : "";
  const abs = Math.abs(v);
  if (compact) {
    if (abs >= 1e9) return `${sign}$${(abs / 1e9).toLocaleString("en-US", { maximumFractionDigits: 2 })}B`;
    if (abs >= 1e6) return `${sign}$${(abs / 1e6).toLocaleString("en-US", { maximumFractionDigits: 2 })}M`;
    if (abs >= 1e3) return `${sign}$${(abs / 1e3).toLocaleString("en-US", { maximumFractionDigits: 1 })}K`;
    return `${sign}$${abs.toLocaleString("en-US", { maximumFractionDigits: 2 })}`;
  }
  return `${sign}$${abs.toLocaleString("en-US", { maximumFractionDigits: 0 })}`;
}

export function fmt(value, currency, rate = 83, opts = {}) {
  return currency === "USD" ? formatUSD(value, { rate, ...opts }) : formatINR(value, opts);
}

export function formatPct(value, digits = 2) {
  if (value === null || value === undefined || isNaN(value)) return "—";
  return `${Number(value).toFixed(digits)}%`;
}
